module.exports = __webpack_public_path__ + "static/media/icon-logout.142efbc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-logout.svg
// module id = 507
// module chunks = 0